import { PaymentTextInput } from 'payments/components/PaymentTextInput';
import { PaymentFieldTypes } from 'payments/constants/card';
import { useCommerceHubPaymentForm } from 'payments/providers/CommerceHubPaymentFormProvider';

export function CommerceHubPostalCodeElement() {
  const commerceHubPaymentForm = useCommerceHubPaymentForm();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    commerceHubPaymentForm?.setPostalCode(e.target.value);

    if (
      commerceHubPaymentForm?.postalCode &&
      commerceHubPaymentForm?.postalCodeError
    ) {
      commerceHubPaymentForm?.setPostalCodeError(null);
    }
  };

  const handleBlur = () => {
    if (commerceHubPaymentForm?.postalCode) {
      commerceHubPaymentForm?.setPostalCodeError(null);
    }
  };

  return (
    <PaymentTextInput
      label="Zip"
      name={PaymentFieldTypes.ZIP_CODE}
      state={commerceHubPaymentForm?.postalCode}
      onChange={handleChange}
      onBlur={handleBlur}
      error={commerceHubPaymentForm?.postalCodeError}
      dataTestId="commerce-hub-zip"
    />
  );
}
